interface RankingBadgeProps {
  eligible?: boolean;
  reason?: string | null;
}

export function RankingBadge({ eligible, reason }: RankingBadgeProps) {
  if (eligible === true) {
    return <span className="badge text-bg-success">Ranking eligible</span>;
  }

  if (eligible === false) {
    return (
      <span className="badge text-bg-warning text-dark" title={reason ?? undefined}>
        Not ranking eligible
      </span>
    );
  }

  return <span className="badge text-bg-secondary">Eligibility unknown</span>;
}
